import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
@Component({
  selector: 'app-zero-balance',
  templateUrl: './zero-balance.component.html',
  styleUrls: ['./zero-balance.component.scss']
})
export class ZeroBalanceComponent implements AfterViewInit {
  zeroBalCols: string[] = ['loan_number', 'payoff_date', 'current_interest_rate'];  
  zero_balance_list:MatTableDataSource<string[]>;
  zeroInterestCols: string[] = ['loan_number', 'current_interest_balance', 'days_past_due', 'current_interest_rate'];    
  zero_with_interest_list:MatTableDataSource<string[]>;
  suspenseCols: string[] = ['loan_number', 'suspense'];    
  suspense_list:MatTableDataSource<string[]>;

  zeroFileSheet: any;
  zeroFile = "Zero_Balance-Report";
  interestFileSheet: any;
  interestFile = "Zero_with_interest-Report";
  suspenseFileSheet: any;
  suspenseFile = "Suspense_list";

  constructor(private apiService: LegacyApiService) { }

  ngAfterViewInit(): void {
    this.apiService.getActiveFilesZeroBalance().subscribe((res: any) => {
      this.zeroFileSheet = res?.zeroBalance;
      this.interestFileSheet = res?.zeroWithInterest;
      this.suspenseFileSheet = res?.suspenseList;
      this.zero_balance_list = new MatTableDataSource(res?.zeroBalance[0]);
      this.zero_with_interest_list = new MatTableDataSource(res?.zeroWithInterest[0]);
      this.suspense_list = new MatTableDataSource(res?.suspenseList[0]);
    });
  }
}
